import { baseTheme } from '@src/theme';
import { Tooltip } from 'antd';
import styled, { css } from 'styled-components';

type StyledTooltipContainerProps = {
    $color: 'primary' | 'secondary';
};

export const StyledTooltip = styled(Tooltip)`
    .ant-tooltip-inner {
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.text ||
            baseTheme.colors.secondary.main.text};
        background: ${(props) =>
            props.theme?.colors?.secondary?.light?.contentBg ||
            baseTheme.colors.secondary.light.contentBg};
        padding: 12px;
        border-radius: 12px;
    }
`;

export const StyledTooltipContainer = styled.div<StyledTooltipContainerProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;

    ${(props) =>
        props.$color === 'primary'
            ? css`
                  background-color: ${props.theme?.colors?.primary?.main
                      ?.filled || baseTheme.colors.primary.main.filled};
                  color: ${props.theme?.colors?.primary?.main?.text ||
                  baseTheme.colors.primary.main.text};
              `
            : css`
                  background-color: ${props.theme?.colors?.primary?.light
                      ?.filled || baseTheme.colors.primary.light.filled};
                  color: ${props.theme?.colors?.primary?.light?.text ||
                  baseTheme.colors.primary.light.text};
              `}
`;
